// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.umbrella-row{display:block ruby;position:relative}div.umbrella-row div{display:block}div.umbrella-row button{display:table-cell;margin-left:16px;padding-left:8px;padding-right:8px}div.umbrella-row div.ac-loading{position:absolute}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
